import TriMoji from "./TriMoji";

const ShockedFeedback = TriMoji({ top: "🤲", mid: "✨", bottom: "😲" });

export default ShockedFeedback;
